<template>
    <div class="flex items-center gap-1">
        <UTooltip
            text="MVA-kodene settes enten fra filen eller er foreslått av systemet. Egendefinerte kontoer som mangler MVA-kode settes til 0. Du kan overstyre dem ved å angi en annen kode i feltene nedenfor."
            :delay-duration="0"
            :content="{
                side: 'top'
            }"
            :ui="{
                content: 'w-72 h-fit overflow-visible',
                text: 'whitespace-pre-line p-1',
            }"
        >
            <i class="i-ph-info inline-block text-xl" />
        </UTooltip>
        MVA
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>